import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vh-100 d-flex justify-content-center align-items-center"
}
const _hoisted_2 = {
  key: 1,
  class: "user-form email-setts"
}
const _hoisted_3 = { class: "user-form profile-form" }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { class: "flex-fill" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-fill-add" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-clockwise" }, null, -1)
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-printer" }, null, -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "team-table" }
const _hoisted_13 = { class: "list-header" }
const _hoisted_14 = { class: "d-flex p-3 justify-content-between" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = {
  for: "itemsPerPage",
  class: "col-form-label"
}
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = {
  for: "search_value",
  class: "col-form-label"
}
const _hoisted_20 = ["placeholder"]
const _hoisted_21 = { class: "rows" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 0,
  class: "bi bi-chevron-down"
}
const _hoisted_24 = {
  key: 1,
  class: "bi bi-chevron-down"
}
const _hoisted_25 = {
  key: 0,
  class: "row-extras"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "bi bi-pencil-square" }, null, -1)
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { key: 1 }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "flex-fill my-2" }
const _hoisted_32 = { class: "area-info text-center text-md-start" }
const _hoisted_33 = { class: "flex-fill" }
const _hoisted_34 = { class: "d-flex justify-content-end" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "clearboth" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_jw_pager = _resolveComponent("jw-pager")!
  const _component_UserSettingsModal = _resolveComponent("UserSettingsModal")!
  const _component_printer_dialog = _resolveComponent("printer-dialog")!

  return (_ctx.isStillLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fa', 'fa-spinner'],
          class: "fs-1"
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", _hoisted_5, [
              _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-users'] }),
              _createTextVNode(" " + _toDisplayString(_ctx.language.users), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                type: "button",
                class: "btn-xs btn-action",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAddUserAction(0, null)))
              }, [
                _hoisted_6,
                _createTextVNode(" " + _toDisplayString(_ctx.language.add_user), 1)
              ]),
              _createTextVNode("  "),
              _createElementVNode("button", {
                type: "button",
                class: "btn-xs btn-action",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.refreshList()))
              }, [
                _hoisted_7,
                _createTextVNode(" " + _toDisplayString(_ctx.language.refresh), 1)
              ]),
              _createTextVNode("  "),
              _createElementVNode("button", {
                type: "button",
                class: "btn-xs btn-action",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.printListItems())),
                disabled: _ctx.listOfAllUsers.length == 0
              }, [
                _hoisted_9,
                _createTextVNode(" " + _toDisplayString(_ctx.language.print), 1)
              ], 8, _hoisted_8)
            ])
          ]),
          (_ctx.localLang == 'en' && (_ctx.connectedUser))
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                _createTextVNode(" You are an "),
                _createElementVNode("strong", null, _toDisplayString((_ctx.connectedUser.IsMainAdmin)?_ctx.language.owner:_ctx.language.admin_sh), 1),
                _createTextVNode(" of "),
                _createElementVNode("strong", null, _toDisplayString(_ctx.connectedDomain.CompanyName), 1),
                _createTextVNode(". Manage your team’s roles and permissions below. ")
              ]))
            : _createCommentVNode("", true),
          (_ctx.localLang == 'fr' && (_ctx.connectedUser))
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                _createTextVNode(" Vous êtes un "),
                _createElementVNode("strong", null, _toDisplayString((_ctx.connectedUser.IsMainAdmin)?_ctx.language.owner:_ctx.language.admin_sh), 1),
                _createTextVNode(" de "),
                _createElementVNode("strong", null, _toDisplayString(_ctx.connectedDomain.CompanyName), 1),
                _createTextVNode(". Gérez les rôles et les autorisations de votre équipe ci-dessous. ")
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("h4", null, [
                _createTextVNode(_toDisplayString(_ctx.language.team) + " ", 1),
                _createElementVNode("span", null, "(" + _toDisplayString(_ctx.listOfAllUsers.length) + ")", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.language.itemsPerPage), 1),
                _withDirectives(_createElementVNode("select", {
                  id: "itemsPerPage",
                  name: "itemsPerPage",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.itemsPerPage) = $event)),
                  class: "form-control-sel"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsPerPageLst, (itPage) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: itPage.id,
                      key: itPage.id
                    }, _toDisplayString(itPage.label), 9, _hoisted_17))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.itemsPerPage]
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.language.search), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "search_value",
                  name: "search_value",
                  maxlength: "25",
                  class: "form-control selectallfocus d-inline pull-right",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchValue) = $event)),
                  placeholder: _ctx.language.search.toLowerCase()
                }, null, 8, _hoisted_20), [
                  [_vModelText, _ctx.searchValue]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usersPageElts, (row) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass([{'expanded':row.IsExpended, 'invite-pending': row.User.WaitForResp}, "row-group"]),
                  key: row.User.UserId
                }, [
                  _createElementVNode("div", {
                    class: "tbl-row",
                    onClick: ($event: any) => (_ctx.appFxs.setExpenderRow(row))
                  }, [
                    _createElementVNode("div", null, _toDisplayString(row.User.FirstName + ' ' + row.User.LastName), 1),
                    _createElementVNode("div", null, _toDisplayString(row.User.Email), 1),
                    _createElementVNode("div", null, [
                      _createTextVNode(_toDisplayString(_ctx.appFxs.getUserStatusName(row)) + " ", 1),
                      (_ctx.appFxs.showUserExtra(row, _ctx.userEmail))
                        ? (_openBlock(), _createElementBlock("em", _hoisted_23))
                        : _createCommentVNode("", true),
                      (!_ctx.appFxs.showUserExtra(row, _ctx.userEmail))
                        ? (_openBlock(), _createElementBlock("em", _hoisted_24))
                        : _createCommentVNode("", true)
                    ])
                  ], 8, _hoisted_22),
                  (_ctx.appFxs.showUserExtra(row, _ctx.userEmail))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("div", null, [
                          (_ctx.appFxs.showEditUserBtn(row, ''))
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: "javascript:;",
                                class: "btn-xs",
                                onClick: ($event: any) => (_ctx.showAddUserAction(1, row))
                              }, [
                                _hoisted_27,
                                _createTextVNode(" " + _toDisplayString(_ctx.language.edit), 1)
                              ], 8, _hoisted_26))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", null, [
                          (row.User.WaitForResp)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: "javascript:;",
                                onClick: ($event: any) => (_ctx.resendEmailRequestJoin(row))
                              }, _toDisplayString(_ctx.language.resend_invite), 9, _hoisted_28))
                            : _createCommentVNode("", true),
                          (row.User.WaitForResp)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_29, "  |  "))
                            : _createCommentVNode("", true),
                          _createElementVNode("a", {
                            href: "javascript:;",
                            onClick: ($event: any) => (_ctx.deleteThisUserSett(row))
                          }, " " + _toDisplayString(_ctx.language.delete_user), 9, _hoisted_30)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128))
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["d-flex justify-content-md-between flex-column flex-md-row py-3", {'d-none': _ctx.listOfAllUsers.length==0}])
            }, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createTextVNode(_toDisplayString(_ctx.language.total_entries) + ": ", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.listOfAllUsers.length), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("nav", _hoisted_34, [
                  _createVNode(_component_jw_pager, {
                    items: _ctx.filteredItems,
                    initialPage: 1,
                    pageSize: _ctx.itemsPerPage,
                    maxPages: 10,
                    onChangePage: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onPageCange($event)))
                  }, null, 8, ["items", "pageSize"])
                ])
              ])
            ], 2)
          ]),
          _hoisted_35,
          (_openBlock(), _createBlock(_Teleport, { to: "#modals-container" }, [
            _createVNode(_component_UserSettingsModal, {
              visible: _ctx.isDialogOpen,
              initialValues: _ctx.dialogRecordData,
              recordStatus: _ctx.dialogRecordStatus,
              onCloseForm: _ctx.onCloseForm
            }, null, 8, ["visible", "initialValues", "recordStatus", "onCloseForm"]),
            _createVNode(_component_printer_dialog, {
              visible: _ctx.isPrintvisible,
              onCloseForm: _ctx.onPrintClose,
              printBaseData: _ctx.printInitialValues,
              extraPrintData: _ctx.printExtraData
            }, null, 8, ["visible", "onCloseForm", "printBaseData", "extraPrintData"])
          ]))
        ])
      ]))
}